import { jsx as _jsx } from "react/jsx-runtime";
import { classNames } from '@common/application/utils/classnames';
import { ScrollToTop } from '@common/components/common/scroll-to-top';
export const FloatingButtons = ({ className }) => {
    return (_jsx("div", Object.assign({ className: classNames('fixed bottom-30 z-2 cursor-pointer', 'right-2.75', 'pc:right-10', className) }, { children: _jsx(ScrollToTop, { className: "static bg-transparent" }) })));
};
